import Table from "components/ui-component/Table";
import { EditButton } from "./CoverPage.style";
import { Modal } from "components/ui-component";
import { Typography } from "antd";
import EditLgIcon from "components/Icons/EditIconLg";

interface AssignedNumbersModalProps {
  visible: boolean;
  onCancelClick: () => void;
  assignedNumbers: any[];
  coverPage: any;
  onEditClick: (coverPage: any) => void;
}

const AssignedNumbersModal = (props: AssignedNumbersModalProps) => {
  const { visible, onCancelClick, assignedNumbers, coverPage, onEditClick } =
    props;

  const columns = [
    {
      title: "Number",
      dataIndex: "did",
      key: "number",
      width: 200,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
  ];

  return (
    <Modal
      open={visible}
      onCancel={onCancelClick}
      cancelText="Close"
      cancelButtonType="primary"
      isOkButton={false}
      title={
        <div className="flex justify-between items-center w-full">
          <div className="modal-title-icon d-flex align-item-center w-100 justify-content-between">
            <Typography.Title level={5}>Assigned Numbers</Typography.Title>
            <EditButton
              onClick={() => onEditClick(coverPage)}
              title="Edit Cover Page"
              size="small"
              icon={<EditLgIcon />}
            />
          </div>
        </div>
      }
      centered
      destroyOnClose
      closable={false}
    >
      <Table
        columns={columns}
        data={assignedNumbers || []}
        pagination={false}
        scroll={{ y: 400 }}
      />
    </Modal>
  );
};

export default AssignedNumbersModal;
